import Vue from 'vue'
import Vuex from 'vuex'
import modules from './modules'

Vue.use(Vuex)

//全局变量
export default new Vuex.Store({ modules })